module.exports = __webpack_public_path__ + "img/18.2a1e7053.png";